<template>
  <div id="app">
    <router-view></router-view> <!-- Dynamically renders components -->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* Add your styles here */
</style>